require("./src/assets/scss/init.scss");

exports.shouldUpdateScroll = () => false;
